<template>
  <div class="pt-3 pb-3">
    <template v-if="type === 'translate'">
      {{ $t("message.common.direction") }}:&nbsp;
      {{ $t("message.common.lang_" + parameters.source_lang) }}
      &rarr;
      {{ $t("message.common.lang_" + parameters.target_lang) }}<br />
      <template v-if="'purpose' in parameters
        && (($store.getters.user && $store.getters.user.allowed_purposes && $store.getters.user.allowed_purposes.length > 1)
        || mode !== 'user')">
        {{ $t("message.common.purpose") }}:&nbsp;
        {{ $t("message.common.purpose_" + parameters.purpose) }}
      </template>
      <template v-if="'translation_parameters' in parameters">
        <v-subheader class="pl-0" @click="open.translation_parameters = !(open.translation_parameters)">
          {{ $t("message.job.translation_parameters") }}:
          <template v-if="open.translation_parameters">
            <v-icon>mdi-menu-up</v-icon>
          </template>
          <template v-else>
            <v-icon>mdi-menu-down</v-icon>
          </template>
        </v-subheader>
      </template>
      <v-card
        v-if="!('translation_parameters' in parameters) || open.translation_parameters"
        :class="('translation_parameters' in parameters) ? 'pl-3' : ''"
        flat
      >
        <template v-if="translation_parameters.model_type === 'field'">
          {{ $t("message.common.general") }}:&nbsp;
          <FieldName
            :id="('translation_parameters' in parameters) ? translation_parameters.field : translation_parameters.model"
            :source_lang="translation_parameters.source_lang"
            :target_lang="translation_parameters.target_lang"
            type="translatable"
          ></FieldName>
          ({{ ('translation_parameters' in parameters) ? translation_parameters.field : translation_parameters.model }})<br />
        </template>
        <template v-else>
          <v-card
            class="d-flex align-center"
            flat
          >
            {{ $t("message.common.model") }}:&nbsp;
            <IdName
              width=""
              :mode="mode"
              type="model"
              :ids="[translation_parameters.model]"
              :nav_path="nav_path"
            >
            </IdName>
          </v-card>
        </template>

        <template v-if="'corpuses' in translation_parameters && translation_parameters.corpuses.length > 0">
          <v-subheader class="pl-0" @click="open.corpuses = !(open.corpuses)">
            {{ $t("message.common.corpus") }}:
            <template v-if="open.corpuses">
              <v-icon>mdi-menu-up</v-icon>
            </template>
            <template v-else>
              <v-icon>mdi-menu-down</v-icon>
            </template>
          </v-subheader>
          <v-card v-if="open.corpuses" flat>
            <template v-for="(corpus, index) in translation_parameters.corpuses">
              <v-card class="d-flex" flat>
                <v-card
                  class="d-flex align-center pr-3"
                  flat
                >
                  {{ index + 1 }}.
                </v-card>
                <IdName
                  width=""
                  :mode="mode"
                  type="corpus"
                  :ids="[corpus]"
                  :nav_path="nav_path"
                >
                </IdName>
              </v-card>
            </template>
          </v-card>
        </template>
        <template v-if="'terms' in translation_parameters && translation_parameters.terms.length > 0">
          <v-subheader class="pl-0" @click="open.terms = !(open.terms)">
            {{ $t("message.common.term") }}:
            <template v-if="open.terms">
              <v-icon>mdi-menu-up</v-icon>
            </template>
            <template v-else>
              <v-icon>mdi-menu-down</v-icon>
            </template>
          </v-subheader>
          <v-card v-if="open.terms" flat>
            {{ $t("message.translate.term_case_sensitive") }}:&nbsp;
            {{ $t("message.common." + (translation_parameters.term_case_sensitive ? "yes" : "no")) }}<br />
            <template v-for="(term, index) in translation_parameters.terms">
              <v-card class="d-flex" flat>
                <v-card
                  class="d-flex align-center pr-3"
                  flat
                >
                  {{ index + 1 }}.
                </v-card>
                <IdName
                  width=""
                  :mode="mode"
                  type="term"
                  :ids="[term]"
                  :nav_path="nav_path"
                >
                </IdName>
              </v-card>
            </template>
          </v-card>
        </template>
        <template v-if="translation_parameters.detail">
          <v-subheader class="pl-0" @click="open.details.detail = !(open.details.detail)">
            {{ $t("message.translate.detail") }}
            <template v-if="open.details.detail">
              <v-icon>mdi-menu-up</v-icon>
            </template>
            <template v-else>
              <v-icon>mdi-menu-down</v-icon>
            </template>
          </v-subheader>
          <v-card v-if="open.details.detail" class="pl-3" flat>
            <template v-if="translation_parameters.detail.tag_option">
              <v-card class="pb-3" flat>
                {{ $t("message.translate.tag_type") }}:&nbsp;
                {{ $t("message.translate." + translation_parameters.detail.tag_option.tag_type) }}
              </v-card>
            </template>
            <template v-if="translation_parameters.detail.style_option_ja">
              <v-subheader class="pl-0 pb-3" :style="{ height: 'auto' }" @click="open.details.style_option_ja = !(open.details.style_option_ja)">
                {{ $t("message.translate.style_option_ja") }}
                <template v-if="open.details.style_option_ja">
                  <v-icon>mdi-menu-up</v-icon>
                </template>
                <template v-else>
                  <v-icon>mdi-menu-down</v-icon>
                </template>
              </v-subheader>
              <v-card v-if="open.details.style_option_ja" class="pl-3 pb-3" flat>
                {{ $t("message.translate.character_style") }}:&nbsp;
                {{ $t("message.translate." + translation_parameters.detail.style_option_ja.character_style) }}<br />
                {{ $t("message.translate.parenthesis_style") }}:&nbsp;
                {{ $t("message.translate." + translation_parameters.detail.style_option_ja.parenthesis_style) }}
                <template v-if="'sentence_style' in translation_parameters.detail.style_option_ja">
                  <br />
                  {{ $t("message.translate.sentence_style") }}:&nbsp;
                  {{ $t("message.translate." + translation_parameters.detail.style_option_ja.sentence_style) }}
                </template>
              </v-card>
            </template>
            <template v-if="translation_parameters.detail.score_threshold
              && $store.getters.user
              && Array.isArray($store.getters.user.allowed_options)
              && $store.getters.user.allowed_options.indexOf('option1') >= 0">
              <v-subheader class="pl-0 pb-3" :style="{ height: 'auto' }" @click="open.details.score_threshold = !(open.details.score_threshold)">
                {{ $t("message.translate.score_threshold") }}
                <template v-if="open.details.score_threshold">
                  <v-icon>mdi-menu-up</v-icon>
                </template>
                <template v-else>
                  <v-icon>mdi-menu-down</v-icon>
                </template>
              </v-subheader>
              <v-card v-if="open.details.score_threshold" class="pl-3 pb-3" flat>
                {{ $t("message.translate.custom_model_similarity") }}:&nbsp;
                {{ translation_parameters.detail.score_threshold.custom_model }}
              </v-card>
            </template>
            <template v-if="translation_parameters.detail.bullet_option">
              <v-card class="pb-3" flat>
                {{ $t("message.translate.bullet_feature") }}:&nbsp;
                {{ $t('message.common.' + (translation_parameters.detail.bullet_option.bullet_feature ? 'yes' : 'no')) }}
              </v-card>
            </template>
          </v-card>
        </template>
      </v-card>
    </template>
    <template v-else-if="type === 'estimate'">
      {{ $t("message.common.language") }}:&nbsp;
      {{ $t("message.common.lang_" + parameters.source_lang) }}
    </template>
    <template v-else-if="type === 'train'">
      {{ $t("message.common.direction") }}:&nbsp;
      {{ $t("message.common.lang_" + parameters.source_lang) }}
      &rarr;
      {{ $t("message.common.lang_" + parameters.target_lang) }}<br />
      {{ $t("message.common.base_model") }}:&nbsp;
      <FieldName
        :id="parameters.field"
        :source_lang="parameters.source_lang"
        :target_lang="parameters.target_lang"
        type="trainable"
      ></FieldName>
      ({{ parameters.field }})
      <template v-if="'first_lang' in parameters && 'second_lang' in parameters">
        <br />
        {{ $t("message.lang_pair_select.first_lang") }}/
        {{ $t("message.lang_pair_select.second_lang") }}:&nbsp;
        {{ $t("message.common.lang_" + parameters.first_lang) }}/
        {{ $t("message.common.lang_" + parameters.second_lang) }}
      </template>
      <template v-if="'purpose' in parameters
        && (($store.getters.user && $store.getters.user.allowed_purposes && $store.getters.user.allowed_purposes.length > 1)
        || mode !== 'user')">
        <br />
        {{ $t("message.common.purpose") }}:&nbsp;
        {{ $t("message.common.purpose_" + parameters.purpose) }}
      </template>
      <template v-if="parameters.detail
        && ['develop', 'in-company'].filter(option => ($store.getters.enable_options.indexOf(option) >= 0)).length > 0">
        <v-subheader class="pl-0" @click="open.details.train = !(open.details.train)">
          {{ $t("message.train.detail") }}
          <template v-if="open.details.train">
            <v-icon>mdi-menu-up</v-icon>
          </template>
          <template v-else>
            <v-icon>mdi-menu-down</v-icon>
          </template>
        </v-subheader>
        <v-card v-if="open.details.train" flat>
          λ:&nbsp;
          {{ parameters.detail.fisher_multiplier }}
        </v-card>
      </template>
    </template>
    <template v-else-if="['corpus_import', 'term_import'].indexOf(type) >= 0">
      <template v-if="'first_lang' in parameters && 'second_lang' in parameters">
        {{ $t("message.lang_pair_select.first_lang") }}/
        {{ $t("message.lang_pair_select.second_lang") }}:&nbsp;
        {{ $t("message.common.lang_" + parameters.first_lang) }}/
        {{ $t("message.common.lang_" + parameters.second_lang) }}
      </template>
      <template v-else>
        -
      </template>
    </template>
    <template v-else-if="type === 'change_name'">
      {{ $t("message.common.type") }}:&nbsp;
      {{ $t("message.common." + parameters.type) }}<br />
      <template v-if="parameters.type === 'group'">
        <v-card
          class="d-flex align-center"
          flat
        >
          {{ $t("message.common.gid") }}:&nbsp;
          <IdName
            width=""
            :mode="mode"
            type="group"
            :ids="[parameters.ids.gid]"
            :nav_path="nav_path"
          >
          </IdName>
        </v-card>
      </template>
      {{ $t("message.common.name") }}:&nbsp;
      {{ parameters.name }}
    </template>
    <template v-else-if="type === 'change_gid'">
      {{ $t("message.common.target") }}:&nbsp;
      {{ $t("message.common." + parameters.operate_target) }}<br />
      <v-card
        class="d-flex align-center"
        flat
      >
        {{ $t("message.common.uid") }}:&nbsp;
        <IdName
          width=""
          :mode="mode"
          type="user"
          :ids="[parameters.uid]"
          :nav_path="nav_path"
        >
        </IdName>
      </v-card>
      <v-card
        class="d-flex align-center"
        flat
      >
        {{ $t("message.common.gid") }}:&nbsp;
        <IdName
          width=""
          :mode="mode"
          type="group"
          :ids="[parameters.last_gid]"
          :nav_path="nav_path"
        >
        </IdName>
        &rarr;
        <IdName
          width=""
          :mode="mode"
          type="group"
          :ids="[parameters.gid]"
          :nav_path="nav_path"
        >
        </IdName>
      </v-card>
    </template>
    <template v-else-if="['batch_user', 'list_user'].indexOf(type) >= 0">
      {{ $t("message.batch_user.output_lang") }}:&nbsp;
      {{ $t("message.common.lang_" + parameters.output_lang) }}
      <template v-if="'gid' in parameters">
        <v-card
          class="d-flex align-center"
          flat
        >
          {{ $t("message.common.gid") }}:&nbsp;
          <IdName
            width=""
            :mode="mode"
            type="group"
            :ids="[parameters.gid]"
            :nav_path="nav_path"
          >
          </IdName>
        </v-card>
      </template>
    </template>
    <template v-else>
      -
    </template>
  </div>
</template>

<script>
import FieldName from '../components/FieldName';
import IdName from '../components/IdName';

export default {
  name: 'job_parameters',
  data: function() {
    return {
      module_id: "69",
      open: {
        translation_parameters: this.expand,
        corpuses: this.expand,
        terms: this.expand,
        details: {
          detail: this.expand,
          style_option_ja: this.expand,
          score_threshold: this.expand,
          train: this.expand
        }
      }
    }
  },
  props: {
    mode: String,
    type: String,
    expand: {
      type: Boolean,
      default: false
    },
    parameters: Object,
    nav_path: String
  },
  components: {
    FieldName,
    IdName
  },
  computed: {
    translation_parameters: function(){
      if('translation_parameters' in this.parameters){
        return this.parameters.translation_parameters;
      }else{
        return this.parameters;
      }
    }
  },
}
</script>
